type urlType = 'tel' | 'mail' | 'link';

const getHref = (url: string, type: urlType): string => {
  if (type === 'tel') return `tel:${url}`;

  if (type === 'mail') return `mailto:${url}`;

  return url;
};

export default getHref;
export type { urlType };
